<template>
  <div class="share-actions" v-if="address">
    <div class="sharing__button active">
      <a
        :class="['share-button', 'share-button--url', shared ? 'shared' : '']"
        @click="shareLink"
        data-copy-text="Copied!"
      >Share Address</a>
      <a class="share-button share-button--google" :href="googleMapsLink">Google Maps</a>
      <a class="share-button share-button--apple" :href="appleMapsLink" v-if="isApplePlatform">Apple Maps</a>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { round, sendEvent } from '@/helpers';

export default {
  data() {
    return {
      shared: false,
    };
  },
  computed: {
    ...mapState(['address', 'location']),
    encodedTitle() {
      return encodeURIComponent(this.address.formattedAddress.replace(/\s/g, '+'));
    },
    latLng() {
      return `${round(this.location.latitude, 5)},${round(this.location.longitude, 5)}`;
    },
    googleMapsLink() {
      return `https://www.google.com/maps/place/${this.encodedTitle}/@${this.latLng}`;
    },
    appleMapsLink() {
      return `https://maps.apple.com/place/?address=${this.encodedTitle}&ll=${this.latLng}`;
    },
    isApplePlatform() {
      const isMac = navigator.platform.includes('Mac');
      const isIOS = RegExp('iPhone|iPad|iPod').test(navigator.platform);
      return isMac || isIOS;
    },
  },
  methods: {
    shareLink() {
      sendEvent('share', 'link');
      const title = this.address.formattedAddress;
      if (typeof navigator.share === 'undefined') {
        navigator.clipboard.writeText(title);
        this.shared = true;
        setTimeout(() => { this.shared = false; }, 1000);
        return;
      }
      navigator.share({
        title,
      });
    },
  },
};
</script>
